// extracted by mini-css-extract-plugin
export var productImage = "_re-1";
export var viewLink = "_re-2";
export var wishlistItem = "_re-0";